const asRoleType = <
  T extends { [K in keyof T]: { name: K; description: string } }
>(
  t: T
) => t;

export const Roles = asRoleType({
  usuario_sincronizar: {
    name: 'usuario_sincronizar',
    description: 'Permite sincronizar usuários'
  },
  usuario_write: {
    name: 'usuario_write',
    description: 'Permite visualizar, cadastrar, editar usuários',
    implies: ['usuario_view', 'permissao_entity_write']
  },
  usuario_read: {
    name: 'usuario_read',
    description: 'Permite listar usuários',
    implies: [
      'usuario_view',
      'sector_config_read',
      'sector_read',
      'grupo_permissao_read'
    ]
  },
  usuario_view: {
    name: 'usuario_view',
    description: 'Permite visualizar usuários',
    implies: ['sector_config_read', 'sector_read', 'grupo_permissao_read']
  },
  usuario_externo_write: {
    name: 'usuario_externo_write',
    description: 'Permite visualizar, cadastrar, editar Usuários Externos',
    implies: ['usuario_externo_read']
  },
  usuario_externo_read: {
    name: 'usuario_externo_read',
    description: 'Permite listar Usuários Externos'
  },
  usuario_externo_view: {
    name: 'usuario_externo_view',
    description: 'Permite visualizar Usuários Externos'
  },
  usuario_password: {
    name: 'usuario_password',
    description: 'Permite alterar a senha do usuário'
  },
  usuario_externo_history: {
    name: 'usuario_externo_history',
    description: 'Permite visualizar o histórico dos usuários externos'
  },
  usuario_history: {
    name: 'usuario_history',
    description: 'Permite visualizar o histórico dos usuários'
  },
  usuario_copy_roles: {
    name: 'usuario_copy_roles',
    description: 'Permite copiar as permissões'
  },
  permissao_write: {
    name: 'permissao_write',
    description: 'Permite vincular permissões aos usuários',
    implies: ['sector_config_read', 'grupo_permissao_read']
  },
  grupo_permissao_read: {
    name: 'grupo_permissao_read',
    description: 'Permite listar os grupos de permissões'
  },
  grupo_permissao_write: {
    name: 'grupo_permissao_write',
    description: 'Permite visualizar, cadastrar, editar grupos de permissões',
    implies: ['grupo_permissao_read']
  },
  grupo_permissao_vinculo_write: {
    name: 'grupo_permissao_vinculo_write',
    description: 'Permite vincular grupos de permissões',
    implies: ['grupo_permissao_read']
  },
  grupo_permissao_copy: {
    name: 'grupo_permissao_copy',
    description: 'Permite copiar os grupos de permissões',
    implies: ['grupo_permissao_read']
  },
  usuario_view_event: {
    name: 'usuario_view_event',
    description:
      'Permite ver os logs de interação do usuário com o sistema (login logout)'
  },
  permissao_entity_write: {
    name: 'permissao_entity_write',
    description: 'Permite vincular entidades ao usuário'
  },
  admin_backup: {
    name: 'admin_backup',
    description: 'Administrar Backups'
  },
  admin_backup_download: {
    name: 'admin_backup_download',
    description: 'Baixar Backups'
  },
  politicas_seguranca: {
    name: 'politicas_seguranca',
    description: 'Políticas de Segurança'
  },
  politicas_seguranca_manage: {
    name: 'politicas_seguranca_manage',
    description: 'Gerenciar Políticas de Segurança'
  },
  sector_config_write: {
    name: 'sector_config_write',
    description:
      'Permite visualizar, cadastrar, editar configurações de setores',
    implies: ['sector_config_read']
  },
  sector_config_read: {
    name: 'sector_config_read',
    description: 'Permite listar configurações de setores'
  },
  sector_read: {
    name: 'sector_read',
    description: 'Permite listar setores',
    implies: ['sector_config_read', 'sector_role_read']
  },
  sector_write: {
    name: 'sector_write',
    description: 'Permite editar setores'
  },
  user_sector_write: {
    name: 'user_sector_write',
    description: 'Permite editar setores do usuário'
  },
  dynamic_form_write: {
    name: 'dynamic_form_write',
    description: 'Permite visualizar, cadastrar, editar formulários dinâmicos'
  },
  dynamic_form_read: {
    name: 'dynamic_form_read',
    description: 'Permite listar formulários dinâmicos'
  },
  sector_role_read: {
    name: 'sector_role_read',
    description: 'Permite listar funções de setores'
  },
  sector_role_write: {
    name: 'sector_role_write',
    description: 'Permite visualizar, cadastrar, editar funções de setores',
    implies: ['sector_role_read']
  },
  remetente_read: {
    name: 'remetente_read',
    description: 'Permite visualizar remetentes'
  },
  remetente_write: {
    name: 'remetente_write',
    description: 'Permite cadastrar e editar remetentes',
    implies: ['remetente_read']
  },
  tipo_verificacao_write: {
    name: 'tipo_verificacao_write',
    description: 'Permite visualizar, ativar e desativar tipos de verificação'
  },
  configuracao_read: {
    name: 'configuracao_read',
    description: 'Permite visualizar a tela de configurações'
  },
  configuracao_write: {
    name: 'configuracao_write',
    description: 'Permite editar os valores na tela de configurações'
  },
  central_comunicacao_read: {
    name: 'central_comunicacao_read',
    description: 'Permite visualizar a tela de central de comunicação'
  },
  central_comunicacao_write: {
    name: 'central_comunicacao_write',
    description: 'Permite cadastrar centrais de comunicações',
    implies: ['remetente_read']
  },
  verificacao_documentos_read: {
    name: 'verificacao_documentos_read',
    description: 'Permite visualizar a tela de verificação de documentos'
  },
  verificacao_documentos_write: {
    name: 'verificacao_documentos_write',
    description: 'Permite editar os valores de verificação de documentos'
  },
  log_revisoes_view: {
    name: 'log_revisoes_view',
    description: 'Permite visualizar a tela de Log Revisões'
  },
  perfil_read: {
    name: 'perfil_read',
    description: 'Permite visualizar a tela de Perfis'
  },
  bloqueio_temporario_view: {
    name: 'bloqueio_temporario_view',
    description: 'Permite visualizar a tela de Bloqueio Temporário'
  },
  bloqueio_temporario_write: {
    name: 'bloqueio_temporario_write',
    description: 'Permite cadastrar e editar bloqueios temporários'
  },
  servico_externo_auditoria_read: {
    name: 'servico_externo_auditoria_read',
    description: 'Permite visualizar a tela de Auditoria de Serviços Externos'
  },
  logs_sistema_read: {
    name: 'logs_sistema_read',
    description: 'Permite visualizar a tela de Logs do Sistema'
  },
  personificacao_read: {
    name: 'personificacao_read',
    description:
      'Permite visulizar a tela com a lista de usuários com a role de Personificação'
  },
  personificacao_write: {
    name: 'personificacao_write',
    description: 'Permite conceder permissão de Personificação'
  },
  consulta_permissao_view: {
    name: 'consulta_permissao_view',
    description: 'Permite visualizar a consulta de permissões.'
  },
  sessao_ativa_read: {
    name: 'sessao_ativa_read',
    description: 'Permite consultar as sessões ativas no servidor'
  },
  sessao_ativa_terminate: {
    name: 'sessao_ativa_terminate',
    description: 'Permite encerrar sessões ativas no servidor'
  }
});
